var map = {
	"./edifici.jpg": 4844,
	"./icono-EMC-negatiu.png": 927,
	"./icono-EMC-negatiu_old.png": 8904,
	"./icono-EMC-positiu.png": 4797,
	"./icono-EMC-positiu_old.png": 5709,
	"./logo-EMC-negatiu.png": 863,
	"./logo-EMC-negatiu_old.png": 9253,
	"./logo-EMC-positiu.png": 8789,
	"./logo-EMC-positiu_old.png": 6045,
	"./logo-white.png": 6286,
	"./logov2-white.png": 6766,
	"./logov2.png": 9774,
	"./nivel1/logov2.png": 984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;